import { render, staticRenderFns } from "./SmsSendPointList.vue?vue&type=template&id=1d8334b8&scoped=true"
import script from "./SmsSendPointList.vue?vue&type=script&lang=js"
export * from "./SmsSendPointList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8334b8",
  null
  
)

export default component.exports